import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Question } from '../../../../../models/suitability/question';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { ReactiveControlsValidator } from '../../../../../extensions/form-validator';
import { Answer } from '../../../../../models/suitability/answer';
import { cloneDeep, get } from 'lodash';

@Component({
  selector: 'app-multi-radio-question',
  templateUrl: './multi-radio-question.component.html',
  styleUrls: ['./multi-radio-question.component.scss']
})
export class MultiRadioQuestionComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() questions: Question[];
  @Input() value?: Question;
  @Input() disabled = false;
  @Input() showUserAnswer: boolean;

  @Output() onAnswerValueChange = new EventEmitter<Question>();

  answerModel: Question;
  header: Array<string>;
  formControl = new Array<FormControl>();

  constructor(protected formBuilder: FormBuilder) {}

  ngOnInit() {}

  ngOnChanges() {
    this.answerModel = cloneDeep(this.value) || {
      id: this.id,
      questions: []
    };

    if (this.questions.length > 0) {
      this.header = this.questions[0].answerses.map((args) => args.description);
      for (let i = 0; i < this.questions.length; i++) {
        this.formControl[i] = this.formBuilder.control(
          { value: '', disabled: this.disabled },
          Validators.required
        );

        if (this.value) {
          const question = this.value.questions.find(
            (args) => args.id === this.questions[i].id
          );
          this.formControl[i].setValue(get(question, 'answer.id', null));
        }
      }
    }
  }

  isInvalidControl(index: number) {
    if (this.formControl[index]) {
      return ReactiveControlsValidator.validateControl(this.formControl[index]);
    }
    return true;
  }

  isValidControl(): boolean {
    return !this.formControl.map((instance) => instance.valid).includes(false);
  }

  getQuestionID(): string {
    return this.id;
  }

  markControlAsTouched() {
    this.formControl
      .filter((control) => control.invalid)
      .forEach((args) => ReactiveControlsValidator.markControlAsTouched(args));
  }

  onAnswerRadioClick(questionID: string, answer: Answer) {
    if (
      this.answerModel.questions.findIndex((args) => args.id === questionID) >
      -1
    ) {
      this.answerModel.questions.splice(
        this.answerModel.questions.findIndex((args) => args.id === questionID),
        1
      );
    }

    this.answerModel.questions.push({ id: questionID, answer});
    this.onAnswerValueChange.emit(this.answerModel);
  }
}
